export interface PlanLimits {
  maxAuthFileSizeMb: number;
  maxAnonymousFileSizeMb: number;
  maxDocumentCount: number;
  maxSharesPerDocument: number;
  // Future fields: maxStorageGb, analyticsRetentionDays, canShareExternally, etc.
}

export type PlanName = 'free'; // extend when adding paid plans: | 'pro' | 'enterprise'

// Values come from env vars so the frontend stays in sync with what the CDK-seeded
// Plans table contains. Defaults mirror the free plan defined in plans.ts (infra).
export const PLANS: Record<PlanName, PlanLimits> = {
  free: {
    maxAuthFileSizeMb: parseInt(process.env.REACT_APP_MAX_AUTH_FILE_SIZE_MB || '25', 10),
    maxAnonymousFileSizeMb: parseInt(process.env.REACT_APP_MAX_ANONYMOUS_FILE_SIZE_MB || '2', 10),
    maxDocumentCount: parseInt(process.env.REACT_APP_MAX_DOCUMENT_COUNT || '10', 10),
    maxSharesPerDocument: parseInt(process.env.REACT_APP_MAX_SHARES_PER_DOCUMENT || '10', 10),
  },
};

export function getPlanLimits(plan: PlanName = 'free'): PlanLimits {
  return PLANS[plan] ?? PLANS.free;
}
